import "@/App.css";
import { BrowserRouter, Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import { I18nProvider } from "@/context/I18nContext";
import { AuthProvider } from "@/context/AuthContext";
import { ConciergeProvider } from "@/context/ConciergeContext";
import { ChatProvider } from "@/context/ChatContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import DigitalAI from "@/pages/DigitalAI";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Chat from "@/pages/Chat";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import { SERVICE_ALIASES } from "@/data/serviceCatalog";
import ProjectLanding from "@/pages/ProjectLanding";
import { useParams } from "react-router-dom";

// /services/:slug — every catalog service renders the same landing layout.
// Old WordPress slugs redirect to their renamed service.
function ServiceRoute() {
  const { slug } = useParams();
  const location = useLocation();
  if (SERVICE_ALIASES[slug]) return <Navigate to={`/services/${SERVICE_ALIASES[slug]}${location.search}${location.hash}`} replace />;
  return <ServiceDetail />;
}
import Locations from "@/pages/Locations";
import CityLanding from "@/pages/CityLanding";
import ComboLanding from "@/pages/ComboLanding";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function NotFound() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-5 text-center">
      <div>
        <p className="font-display text-7xl text-primary">404</p>
        <h1 className="font-display uppercase tracking-tight text-3xl mt-4">Page not found</h1>
        <Link to="/" className="mt-6 inline-flex bg-primary text-primary-foreground font-mono-tech text-xs tracking-widest uppercase px-6 h-12 items-center">
          Back home
        </Link>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <I18nProvider>
          <AuthProvider>
            <BrowserRouter>
              <ConciergeProvider>
                <ChatProvider>
                <Routes>
                  <Route element={<Layout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/showroom" element={<Navigate to="/services" replace />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/services/:slug" element={<ServiceRoute />} />
                    <Route path="/start/:slug" element={<ProjectLanding />} />
                    <Route path="/locations" element={<Locations />} />
                    <Route path="/locations/:slug" element={<CityLanding />} />
                    <Route path="/construction" element={<Navigate to="/services" replace />} />
                    <Route path="/digital" element={<DigitalAI />} />
                    <Route path="/work" element={<Navigate to="/services" replace />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/chat" element={<Chat />} />
                    <Route path="/:combo" element={<ComboLanding />} />
                    <Route path="*" element={<NotFound />} />
                  </Route>
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                </Routes>
                </ChatProvider>
              </ConciergeProvider>
            </BrowserRouter>
          </AuthProvider>
        </I18nProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
